export enum DeliveryModeEnum {
  DEFAULT = 'DEFAULT',
  AIRPLANE = 'AIRPLANE',
}
